import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhotoFilm } from '@fortawesome/pro-light-svg-icons/faPhotoFilm';
import type { ResolvedMediaFile } from 'fym-shared/src/smartlinks/mediaWidget';
import { TypedMemo } from '../../../../common/types';
import styles from './MediaBlockThumb.module.scss';

interface MediaBlockThumbProps {
  media: ResolvedMediaFile | null;
}

/** The picture of the media file a block shows, else null. A thumbnail first, then the poster. */
export function mediaThumbUrl(media: ResolvedMediaFile | null): string | null {
  if (media === null) {
    return null;
  }
  return media.thumbUrl ?? media.posterUrl ?? (media.kind === 'image' ? media.url : null);
}

/**
 * The small picture of a Media block in the block list (design a3): 34 px square, or 26 × 40 for a
 * tall file. A block with no file shows the icon of the block type.
 */
const MediaBlockThumbComponent: React.FC<MediaBlockThumbProps> = ({ media }) => {
  const url = mediaThumbUrl(media);
  const isTall = media !== null && media.width !== null && media.height !== null && media.height > media.width;
  if (url === null) {
    return (
      <span className={styles.thumbFrame}>
        <FontAwesomeIcon icon={faPhotoFilm} />
      </span>
    );
  }
  return (
    <span className={clsx(styles.thumbFrame, isTall && styles.thumbTall)}>
      <img className={styles.thumbImage} src={url} alt="" loading="lazy" data-testid="media-block-thumb" />
    </span>
  );
};

export const MediaBlockThumb = TypedMemo(MediaBlockThumbComponent);
